import React from 'react'
import MyProfileUploadDocumentationStatus from "./myProfileUploadDocumentationStatus";
import { translateText, translateTextHtml } from "../getTranslationsMyProfileUploadDocumentation";

const IconCheck = require('assets/images/icon-check-green-black.svg')

export const MyProfileUploadDocumentationSuccess = () => (
    <MyProfileUploadDocumentationStatus
        showButton
        icon={IconCheck}
        title={translateText('successTitle')}
        text={translateTextHtml('successBody')}
        status={"success"}
    />
)
